
// import Bar from "../components/Bar.vue";
import Breed from "../components/Breed.vue";
import Formm from "../components/Formm.vue";
import Foot from "../components/Foot.vue";
import JsonPosts from "@/assets/posts_home.json";

export default {
  name: "post",
  components: {
    // Bar,
    Formm,
    Foot,
    Breed,
  },
  data: function () {
    return {
      posts: JsonPosts,
      post: {},
    };
  },
  mounted() {
    let that = this as any;
    if (that.$route.params && that.$route.params.id) {
      let findPost = that.posts.filter(
        (x: any) => x.id == that.$route.params.id
      );
      if (findPost.length) {
        that.post = findPost[0];
      }
    }
  },
};
